import {Configuration, DefaultApi} from "@amzn/drsn-optin-optout-typescript-client";
import {getApiBaseUrl} from "src/utils/apiUtils";

export default function () {
    return new DefaultApi(new Configuration({
        basePath: getApiBaseUrl("prod"),
        headers: {'Content-Type': 'application/json'},
    }));
};